import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Header } from "@/components/Header";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "html-react-parser";
import { CssCampanhasTabs, CssHome, CssSuvinilCase, CssSuvinilOutdoor, CssSuvinilCards, CssSuvinilMetricas, CssSuvinilCores, CssSuvinilCoresDetalhes, CssSuvinilCoresFilmes, CssEdpCase, CssEdpSocial, CssEdpNotebook, CssEdpNovoCase, CssEdpNovoResultados, CssEdpFullResponsa, CssEcomCase } from "./css";

import logoSuvinil from "@/assets/cases/campanhas/logoSuvinil.jpg";
import revistaSuvinil from "@/assets/cases/campanhas/revista.png";
import setaAzul from "@/assets/cases/campanhas/setaAzul.png";
import outdoorSuvinil from "@/assets/cases/campanhas/outdoor.jpg";
import quadradoVermelho from "@/assets/cases/campanhas/quadradoVermelho.png";
import setaVermelha from "@/assets/cases/campanhas/setaVermelha.png";
import fundoSuvinil from "@/assets/cases/campanhas/fundoSuvinil.jpg";
import trainguloBranco from "@/assets/cases/campanhas/trainguloBranco.png";
//import bannerSuvinilCores from "@/assets/cases/campanhas/BannerSuvinilCores.jpg";
import trianguloInvertidoAzul from "@/assets/cases/campanhas/trianguloInvertidoAzul.png";
import trianguloInvertidoAzulVazio from "@/assets/cases/campanhas/trianguloInvertidoAzulVazio.png";
import celularCores from "@/assets/cases/campanhas/celularCores.png";
import quadroCores from "@/assets/cases/campanhas/quadroCores.png";
import setaVirada from "@/assets/cases/campanhas/setaVirada.png";
import filmesCores from "@/assets/cases/campanhas/filmes.png";
import notebookCores from "@/assets/cases/campanhas/notebookCores.png";
import trianguloVermelhoCores from "@/assets/cases/campanhas/trianguloVermelhoCores.png";
import trianguloVermelhoVazado from "@/assets/cases/campanhas/trianguloVermelhoVazado.png";
import facebookCores from "@/assets/cases/campanhas/facebook.png";
import instagramCores from "@/assets/cases/campanhas/instagram.png";
import youtubeCores from "@/assets/cases/campanhas/youtube.png";
import capaEdp from "@/assets/cases/campanhas/edp/capaEdp.jpg";
import bannerMulherEdp from "@/assets/cases/campanhas/edp/bannerMulher.jpg";
import trianguloEdpInferior from "@/assets/cases/campanhas/edp/trianguloInvertidoAzulVazio.png";
import trianguloEdpSuperior from "@/assets/cases/campanhas/edp/trianguloInvertidoSuperiorAzulVazio.png";
import celularEdp from "@/assets/cases/campanhas/edp/celular.png";
import cardEdp1 from "@/assets/cases/campanhas/edp/card1.jpg";
import cardEdp2 from "@/assets/cases/campanhas/edp/card2.jpg";
import setaDireitaEdp from "@/assets/cases/campanhas/edp/seta-direita.png";
import notebookEdp from "@/assets/cases/campanhas/edp/notebook.png";
import trianguloVermelhoEdp from "@/assets/cases/campanhas/edp/trianguloVermelho.png";
import triangulosJuntosEdp from "@/assets/cases/campanhas/edp/triangulosJuntos.png";
import quadradoVermelhoEdp from "@/assets/cases/campanhas/edp/quadradoVermelho.png";
import instagramEdp from "@/assets/cases/campanhas/edp/instagram.png";
import youtubeEdp from "@/assets/cases/campanhas/edp/youtube.png";
import setaViradaEdp from "@/assets/cases/campanhas/edp/setaVirada.png";
import pcEdp from "@/assets/cases/campanhas/edp/pc.png";
import cardsEdp from "@/assets/cases/campanhas/edp/cardsEDP.png";
import trianguloVermelhoCoresEdp from "@/assets/cases/campanhas/edp/trianguloVermelhoCores.png";
import trianguloVermelhoInvertidoEdp from "@/assets/cases/campanhas/edp/trianguloVermelhoInvertido.png";
import fotoJuntoEdp1 from "@/assets/cases/campanhas/edp/fotoJunto1.jpg";
import fotoJuntoEdp2 from "@/assets/cases/campanhas/edp/fotoJunto2.jpg";
import celularEcom from "@/assets/cases/campanhas/ecom/celular.png";
import triangulosJuntosEcom from "@/assets/cases/campanhas/ecom/triangulosJuntos.png";
import setaViradaEcom from "@/assets/cases/campanhas/ecom/setaVirada.png";
import postEcom1 from "@/assets/cases/campanhas/ecom/post1.png";
import postEcom2 from "@/assets/cases/campanhas/ecom/post2.png";
import postEcom3 from "@/assets/cases/campanhas/ecom/post3.png";
import postEcom4 from "@/assets/cases/campanhas/ecom/post4.png";
import instaEcom1 from "@/assets/cases/campanhas/ecom/insta1.png";
import instaEcom2 from "@/assets/cases/campanhas/ecom/insta2.png";
import instaEcom3 from "@/assets/cases/campanhas/ecom/insta3.png";
import instaEcom4 from "@/assets/cases/campanhas/ecom/insta4.png";
import cardEcom from "@/assets/cases/campanhas/ecom/cards.png";
import laptopEcom from "@/assets/cases/campanhas/ecom/laptop.png";
import zBegeEcom from "@/assets/cases/campanhas/ecom/zBege.png";
/* import facebookEcom from "@/assets/cases/campanhas/ecom/facebook.png";
import instagramEcom from "@/assets/cases/campanhas/ecom/instagram.png";
import youtubeEcom from "@/assets/cases/campanhas/ecom/youtube.png";
import zeEcom from "@/assets/cases/campanhas/ecom/ze.png"; */
import fotoEcom1 from "@/assets/cases/campanhas/ecom/foto1.jpg";
import fotoEcom2 from "@/assets/cases/campanhas/ecom/foto2.jpg";
import fotoEcom3 from "@/assets/cases/campanhas/ecom/foto3.jpg";
import fotoEcom4 from "@/assets/cases/campanhas/ecom/foto4.jpg";
import fotoEcom5 from "@/assets/cases/campanhas/ecom/foto5.jpg";
import fotoEcom6 from "@/assets/cases/campanhas/ecom/foto6.jpg";
import fotoEcom7 from "@/assets/cases/campanhas/ecom/foto7.jpg";
import fotoEcom8 from "@/assets/cases/campanhas/ecom/foto8.jpg";
import fotoEcom9 from "@/assets/cases/campanhas/ecom/foto9.jpg";
import fotoEcom10 from "@/assets/cases/campanhas/ecom/foto10.jpg";
import fotoEcom11 from "@/assets/cases/campanhas/ecom/foto11.jpg";
import fotoEcom12 from "@/assets/cases/campanhas/ecom/foto12.jpg";

const edpNovoVideoUrl = "https://player.vimeo.com/video/1002934993?autoplay=1&muted=1&loop=1&autopause=0";
const ecomVideoUrl = "https://player.vimeo.com/video/1207846721?autoplay=1&muted=1&loop=1&autopause=0";
const ecomPosts = [postEcom1, postEcom2, postEcom3, postEcom4];
const ecomInstas = [instaEcom1, instaEcom2, instaEcom3, instaEcom4];
const ecomFotos = [fotoEcom1, fotoEcom2, fotoEcom3, fotoEcom4, fotoEcom5, fotoEcom6, fotoEcom7, fotoEcom8, fotoEcom9, fotoEcom10, fotoEcom11, fotoEcom12];

const CasesCampanhas = () => {
	const { t } = useTranslation();
        const [activeCase, setActiveCase] = useState("suvinil");
	const suvinilOutdoorRef = useRef(null);
	const suvinilCardsRef = useRef(null);
	const suvinilMetricasRef = useRef(null);
	const suvinilCoresRef = useRef(null);
	const suvinilCoresDetalhesRef = useRef(null);
	const suvinilCoresFilmesRef = useRef(null);
	const edpCaseRef = useRef(null);
	const edpSocialRef = useRef(null);
	const edpNotebookRef = useRef(null);
	const edpNovoCaseRef = useRef(null);
	const edpNovoResultadosRef = useRef(null);
	const edpFullResponsaRef = useRef(null);
	const ecomVideoRef = useRef(null);
	const ecomCelularRef = useRef(null);
	const ecomPostsRef = useRef(null);
	const ecomNotebookRef = useRef(null);
	const ecomFotosRef = useRef(null);
	const [animateHome, setAnimateHome] = useState(false);
	const [animateSuvinilCase, setAnimateSuvinilCase] = useState(false);
	const [animateSuvinilOutdoor, setAnimateSuvinilOutdoor] = useState(false);
	const [animateSuvinilCards, setAnimateSuvinilCards] = useState(false);
	const [animateSuvinilMetricas, setAnimateSuvinilMetricas] = useState(false);
	const [animateSuvinilCores, setAnimateSuvinilCores] = useState(false);
	const [animateSuvinilCoresDetalhes, setAnimateSuvinilCoresDetalhes] = useState(false);
	const [animateSuvinilCoresFilmes, setAnimateSuvinilCoresFilmes] = useState(false);
	const [animateEdpCase, setAnimateEdpCase] = useState(false);
	const [animateEdpSocial, setAnimateEdpSocial] = useState(false);
	const [animateEdpNotebook, setAnimateEdpNotebook] = useState(false);
	const [animateEdpNovoCase, setAnimateEdpNovoCase] = useState(false);
	const [animateEdpNovoResultados, setAnimateEdpNovoResultados] = useState(false);
	const [animateEdpFullResponsa, setAnimateEdpFullResponsa] = useState(false);
	const [animateEcomTitulo, setAnimateEcomTitulo] = useState(false);
	const [animateEcomVideo, setAnimateEcomVideo] = useState(false);
	const [animateEcomCelular, setAnimateEcomCelular] = useState(false);
	const [animateEcomPosts, setAnimateEcomPosts] = useState(false);
	const [animateEcomNotebook, setAnimateEcomNotebook] = useState(false);
	const [animateEcomFotos, setAnimateEcomFotos] = useState(false);

	useEffect(() => {
			window.scrollTo({ top: 0, behavior: "smooth" });

			setAnimateEdpCase(false);
			setAnimateEdpSocial(false);
			setAnimateEdpNotebook(false);
			setAnimateEdpNovoCase(false);
			setAnimateEdpNovoResultados(false);
			setAnimateEdpFullResponsa(false);
			setAnimateEcomTitulo(false);
			setAnimateEcomVideo(false);
			setAnimateEcomCelular(false);
			setAnimateEcomPosts(false);
			setAnimateEcomNotebook(false);
			setAnimateEcomFotos(false);

			if (activeCase === "ecom") {
				const timer = setTimeout(() => setAnimateEcomTitulo(true), 80);
				return () => clearTimeout(timer);
			}
	}, [activeCase]);

	useEffect(() => {
		if (activeCase !== "ecom") return undefined;

		const ecomVideo = ecomVideoRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateEcomVideo(true);
					}
				});
			},
			{ threshold: 0.22 }
		);

		if (ecomVideo) observer.observe(ecomVideo);

		return () => {
			if (ecomVideo) observer.unobserve(ecomVideo);
		};
	}, [activeCase]);

	useEffect(() => {
		if (activeCase !== "ecom") return undefined;

		const ecomCelular = ecomCelularRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateEcomCelular(true);
					}
				});
			},
			{ threshold: 0.18 }
		);

		if (ecomCelular) observer.observe(ecomCelular);

		return () => {
			if (ecomCelular) observer.unobserve(ecomCelular);
		};
	}, [activeCase]);

	useEffect(() => {
		if (activeCase !== "ecom") return undefined;

		const ecomPosts = ecomPostsRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateEcomPosts(true);
					}
				});
			},
			{ threshold: 0.12 }
		);

		if (ecomPosts) observer.observe(ecomPosts);

		return () => {
			if (ecomPosts) observer.unobserve(ecomPosts);
		};
	}, [activeCase]);

	useEffect(() => {
		if (activeCase !== "ecom") return undefined;

		const ecomNotebook = ecomNotebookRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateEcomNotebook(true);
					}
				});
			},
			{ threshold: 0.18 }
		);

		if (ecomNotebook) observer.observe(ecomNotebook);

		return () => {
			if (ecomNotebook) observer.unobserve(ecomNotebook);
		};
	}, [activeCase]);

	useEffect(() => {
		if (activeCase !== "ecom") return undefined;

		const ecomFotos = ecomFotosRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateEcomFotos(true);
					}
				});
			},
			{ threshold: 0.1 }
		);

		if (ecomFotos) observer.observe(ecomFotos);

		return () => {
			if (ecomFotos) observer.unobserve(ecomFotos);
		};
	}, [activeCase]);

	useEffect(() => {
		setAnimateHome(true);
	}, []);

	useEffect(() => {
		const suvinilCase = document.querySelector(".suvinilCaseSection");

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateSuvinilCase(true);
					}
				});
			},
			{ threshold: 0.25 }
		);

		if (suvinilCase) observer.observe(suvinilCase);

		return () => {
			if (suvinilCase) observer.unobserve(suvinilCase);
		};
	}, []);

	useEffect(() => {
		const suvinilOutdoor = suvinilOutdoorRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateSuvinilOutdoor(true);
					}
				});
			},
			{ threshold: 0.2 }
		);

		if (suvinilOutdoor) observer.observe(suvinilOutdoor);

		return () => {
			if (suvinilOutdoor) observer.unobserve(suvinilOutdoor);
		};
	}, []);

	useEffect(() => {
		const suvinilCards = suvinilCardsRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateSuvinilCards(true);
					}
				});
			},
			{ threshold: 0.2 }
		);

		if (suvinilCards) observer.observe(suvinilCards);

		return () => {
			if (suvinilCards) observer.unobserve(suvinilCards);
		};
	}, []);

	useEffect(() => {
		const suvinilMetricas = suvinilMetricasRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateSuvinilMetricas(true);
					}
				});
			},
			{ threshold: 0.2 }
		);

		if (suvinilMetricas) observer.observe(suvinilMetricas);

		return () => {
			if (suvinilMetricas) observer.unobserve(suvinilMetricas);
		};
	}, []);

	useEffect(() => {
		const suvinilCores = suvinilCoresRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateSuvinilCores(true);
					}
				});
			},
			{ threshold: 0.2 }
		);

		if (suvinilCores) observer.observe(suvinilCores);

		return () => {
			if (suvinilCores) observer.unobserve(suvinilCores);
		};
	}, []);

	useEffect(() => {
		const suvinilCoresDetalhes = suvinilCoresDetalhesRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateSuvinilCoresDetalhes(true);
					}
				});
			},
			{ threshold: 0.2 }
		);

		if (suvinilCoresDetalhes) observer.observe(suvinilCoresDetalhes);

		return () => {
			if (suvinilCoresDetalhes) observer.unobserve(suvinilCoresDetalhes);
		};
	}, []);

	useEffect(() => {
		const suvinilCoresFilmes = suvinilCoresFilmesRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateSuvinilCoresFilmes(true);
					}
				});
			},
			{ threshold: 0.15 }
		);

		if (suvinilCoresFilmes) observer.observe(suvinilCoresFilmes);

		return () => {
			if (suvinilCoresFilmes) observer.unobserve(suvinilCoresFilmes);
		};
	}, []);

	useEffect(() => {
		if (activeCase !== "edp") return undefined;

		const edpCase = edpCaseRef.current;
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setAnimateEdpCase(true);
					}
				});
			},
			{ threshold: 0.2 }
		);

		if (edpCase) observer.observe(edpCase);

		return () => {
			if (edpCase) observer.unobserve(edpCase);
		};
	}, [activeCase]);

	useEffect(() => {
			if (activeCase !== "edp") return undefined;

			const edpSocial = edpSocialRef.current;
			const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					setAnimateEdpSocial(true);
				}
			});
		},
		{ threshold: 0.2 }
	);

	if (edpSocial) observer.observe(edpSocial);

	return () => {
					if (edpSocial) observer.unobserve(edpSocial);
			};
	}, [activeCase]);

	useEffect(() => {
			if (activeCase !== "edp") return undefined;

			const edpNotebook = edpNotebookRef.current;
			const observer = new IntersectionObserver(
				(entries) => {
						entries.forEach((entry) => {
								if (entry.isIntersecting) {
										setAnimateEdpNotebook(true);
								}
						});
				},
				{ threshold: 0.2 }
		);

		if (edpNotebook) observer.observe(edpNotebook);

		return () => {
				if (edpNotebook) observer.unobserve(edpNotebook);
			};
	}, [activeCase]);

	useEffect(() => {
			if (activeCase !== "edp") return undefined;

			const edpNovoCase = edpNovoCaseRef.current;
			const observer = new IntersectionObserver(
					(entries) => {
							entries.forEach((entry) => {
									if (entry.isIntersecting) {
											setAnimateEdpNovoCase(true);
									}
							});
					},
					{ threshold: 0.2 }
			);

			if (edpNovoCase) observer.observe(edpNovoCase);

			return () => {
					if (edpNovoCase) observer.unobserve(edpNovoCase);
			};
	}, [activeCase]);

	useEffect(() => {
			if (activeCase !== "edp") return undefined;

			const edpNovoResultados = edpNovoResultadosRef.current;
			const observer = new IntersectionObserver(
					(entries) => {
							entries.forEach((entry) => {
									if (entry.isIntersecting) {
											setAnimateEdpNovoResultados(true);
									}
							});
					},
					{ threshold: 0.16 }
			);

			if (edpNovoResultados) observer.observe(edpNovoResultados);

			return () => {
					if (edpNovoResultados) observer.unobserve(edpNovoResultados);
			};
	}, [activeCase]);

	useEffect(() => {
			if (activeCase !== "edp") return undefined;

			const edpFullResponsa = edpFullResponsaRef.current;
			const observer = new IntersectionObserver(
					(entries) => {
							entries.forEach((entry) => {
									if (entry.isIntersecting) {
											setAnimateEdpFullResponsa(true);
									}
							});
					},
					{ threshold: 0.18 }
			);

			if (edpFullResponsa) observer.observe(edpFullResponsa);

			return () => {
					if (edpFullResponsa) observer.unobserve(edpFullResponsa);
			};
	}, [activeCase]);

        return (
		<>
			<Helmet>
				<title>Zest Ag | Cases | Campanhas</title>

				<link rel="shortcut icon" href="https://zest.ag/favicon.png?v=3" />
				<link rel="icon" type="image/png" href="https://zest.ag/favicon.png?v=3" />
				<link rel="apple-touch-icon" href="https://zest.ag/favicon.png?v=3" />

				<meta name="description" content="Zest AG - The full responsa agency" />
				<meta name="keywords" content="Zest One, Agência de marketing, negócios e interesses do cliente, inbound"/>

				<meta property="og:url" content="https://zest.ag/CasesCampanhas" />
				<meta property="og:type" content="website" />
				<meta property="og:title" content="Zest Ag | Cases | Campanhas" />
				<meta property="og:description" content="Zest Ag - The full responsa agency" />
				<meta property="og:image" content="https://zest.ag/avatar.jpg" />
			</Helmet>

			<Header />
			<div className="clear" />

				<CssCampanhasTabs>
					<div className="campanhasTabs" role="tablist" aria-label="Cases de campanhas">
							<button
									type="button"
									role="tab"
									aria-selected={activeCase === "suvinil"}
									className={`campanhasTab ${activeCase === "suvinil" ? "campanhasTabAtiva" : ""}`}
									onClick={() => setActiveCase("suvinil")}
							>
									<span>SUVINIL</span>
							</button>

							<button
									type="button"
									role="tab"
									aria-selected={activeCase === "edp"}
									className={`campanhasTab ${activeCase === "edp" ? "campanhasTabAtiva" : ""}`}
									onClick={() => setActiveCase("edp")}
							>
									<span>EDP</span>
							</button>

							<button
									type="button"
									role="tab"
									aria-selected={activeCase === "ecom"}
									className={`campanhasTab ${activeCase === "ecom" ? "campanhasTabAtiva" : ""}`}
									onClick={() => setActiveCase("ecom")}
							>
									<span>ECOM</span>
							</button>
					</div>
				</CssCampanhasTabs>

				<div
						className="campanhasTabPanel"
						role="tabpanel"
						hidden={activeCase !== "suvinil"}
				>
					<CssHome>
						<section
							className={`campanhasSuvinilHero ${animateHome ? "animateSuvinilHome" : ""}`}
						>
							<div className="campanhasSuvinilLogoWrap">
								<h1 className="campanhasSuvinilTitulo">
									{ReactHtmlParser(t("casesCampanhas.suvinilChamada"))}
								</h1>
							</div>

							<div className="campanhasSuvinilCapaWrap">
									<iframe
										src="https://player.vimeo.com/video/998835918?autoplay=1&muted=1&loop=1&autopause=0"
										title="Vídeo ZEST"
										frameBorder="0"
										allow="autoplay; fullscreen; picture-in-picture"
										allowFullScreen
									/>
								{/* <img
									src={capaSuvinil}
									alt="Nossa historia mora em voce"
									className="campanhasSuvinilCapa"
								/> */}
							</div>
						</section>
					</CssHome>

					<CssSuvinilCase>
						<section
							className={`suvinilCaseSection ${animateSuvinilCase ? "animateSuvinilCase" : ""}`}
						>
							<div className="suvinilCaseContainer">
								<img
									src={logoSuvinil}
									alt="Suvinil 60 anos"
									className="suvinilCaseLogo animSuvinilLogo"
								/>

								<div className="suvinilCaseTexto suvinilCaseTexto1 animSuvinilTexto1">
									{ReactHtmlParser(t("casesCampanhas.suvinilTexto1"))}
								</div>

								<div className="suvinilCaseTexto suvinilCaseTexto2 animSuvinilTexto2">
									{ReactHtmlParser(t("casesCampanhas.suvinilTexto2"))}
								</div>

								<img
									src={setaAzul}
									alt=""
									className="suvinilCaseSeta animSuvinilSeta"
								/>

								<strong className="suvinilCaseNumero animSuvinilNumero">01</strong>

								<img
									src={revistaSuvinil}
									alt="Revista Suvinil 60 anos"
									className="suvinilCaseRevista animSuvinilRevista"
								/>

								<div className="suvinilCaseCanto animSuvinilCanto" />
								<div className="suvinilCaseContorno animSuvinilContorno" />
							</div>
						</section>
					</CssSuvinilCase>

					<CssSuvinilOutdoor>
						<section
							ref={suvinilOutdoorRef}
							className={`suvinilOutdoorSection ${animateSuvinilOutdoor ? "animateSuvinilOutdoor" : ""}`}
						>
							<div className="suvinilOutdoorContainer">
								<strong className="suvinilOutdoorNumero animOutdoorNumero">02</strong>

								<div className="suvinilOutdoorFaixa animOutdoorFaixa" />

								<img
									src={outdoorSuvinil}
									alt="Outdoor Suvinil 60 anos"
									className="suvinilOutdoorImg animOutdoorImg"
								/>

								<div className="suvinilOutdoorTextoTopo animOutdoorTextoTopo">
									<img
										src={quadradoVermelho}
										alt=""
										className="suvinilOutdoorQuadrado"
									/>
									<img
										src={setaVermelha}
										alt=""
										className="suvinilOutdoorSeta"
									/>
									{ReactHtmlParser(t("casesCampanhas.suvinilOutdoorTitulo"))}
								</div>

								<div className="suvinilOutdoorElemento animOutdoorElemento" />
								<div className="suvinilOutdoorVazado animOutdoorVazado" />

								<div className="suvinilOutdoorTextoBaixo animOutdoorTextoBaixo">
									{ReactHtmlParser(t("casesCampanhas.suvinilOutdoorTexto"))}
								</div>

								<div className="suvinilOutdoorLorem animOutdoorLorem">
									{ReactHtmlParser(t("casesCampanhas.suvinilOutdoorLorem"))}
								</div>
							</div>
						</section>
					</CssSuvinilOutdoor>

					<CssSuvinilCards>
						<section
							ref={suvinilCardsRef}
							className={`suvinilCardsSection ${animateSuvinilCards ? "animateSuvinilCards" : ""}`}
						>
							<img
								src={fundoSuvinil}
								alt=""
								className="suvinilCardsFundo"
							/>

							<div className="suvinilCardsContent">
								<strong className="suvinilCardsNumero animCardsNumero">03</strong>

								<div className="suvinilCardsTexto animCardsTexto">
									{ReactHtmlParser(t("casesCampanhas.suvinilCardsTitulo"))}
								</div>

								<div className="suvinilCardsDescricao animCardsTexto">
									{ReactHtmlParser(t("casesCampanhas.suvinilCardsTexto"))}
								</div>

								<img
									src={trainguloBranco}
									alt=""
									className="suvinilCardsTriangulo suvinilCardsTrianguloLeft animCardsTrianguloLeft"
								/>
								<img
									src={trainguloBranco}
									alt=""
									className="suvinilCardsTriangulo suvinilCardsTrianguloTop animCardsTrianguloTop"
								/>
								<img
									src={trainguloBranco}
									alt=""
									className="suvinilCardsTriangulo suvinilCardsTrianguloTopMenor animCardsTrianguloTop"
								/>
							</div>
						</section>
					</CssSuvinilCards>

					<CssSuvinilMetricas>
						<section
							ref={suvinilMetricasRef}
							className={`suvinilMetricasSection ${animateSuvinilMetricas ? "animateSuvinilMetricas" : ""}`}
						>
							<div className="suvinilMetricasContainer">
								{/* <div className="suvinilMetricasFotoWrap animMetricasFoto">
									<img src={fotoJaponesa} alt="" className="suvinilMetricasFoto" />
								</div>

								<img src={trianguloVermelho} alt="" className="suvinilMetricasTriangulo animMetricasTriangulo" />

								<strong className="suvinilMetricasNumero suvinilMetricasNumeroTop animMetricas200">200K</strong>

								<div className="suvinilMetricasSocial">
									<img src={facebook} alt="Facebook" className="suvinilMetricasIcon animMetricasIcon icon1" />
									<img src={tiktok} alt="TikTok" className="suvinilMetricasIcon animMetricasIcon icon2" />
									<img src={instagram} alt="Instagram" className="suvinilMetricasIcon animMetricasIcon icon3" />
									<img src={youtube} alt="YouTube" className="suvinilMetricasIcon animMetricasIcon icon4" />
									<img src={quadradoVermelho} alt="" className="suvinilMetricasLogo animMetricasIcon icon5" />
								</div>

								<div className="suvinilMetricasViews animMetricasViews">
									<strong>{t("casesCampanhas.suvinilMetricasViewsTitulo")}</strong>
									{ReactHtmlParser(t("casesCampanhas.suvinilMetricasViewsTexto"))}
								</div>

								<div className="suvinilMetricasInferior suvinilMetricas55 animMetricas55">
									<strong>+55M</strong>
									{ReactHtmlParser(t("casesCampanhas.suvinilMetricas55Texto"))}
								</div>

								<div className="suvinilMetricasInferior suvinilMetricas100 animMetricas100">
									<strong>100K</strong>
									{ReactHtmlParser(t("casesCampanhas.suvinilMetricas100Texto"))}
								</div>

								<img src={trianguloAzul} alt="" className="suvinilMetricasAzul animMetricasAzul" />
								*/}

							{/* 	<div className="suvinilMetricasVideoWrap animMetricasVideo">
									<iframe
										src="https://player.vimeo.com/video/998835918?autoplay=1&muted=1&loop=1&autopause=0"
										title="Vídeo ZEST"
										frameBorder="0"
										allow="autoplay; fullscreen; picture-in-picture"
										allowFullScreen
									/>
								</div> */}
							</div>
						</section>
					</CssSuvinilMetricas>

					<CssSuvinilCores>
						<section
							ref={suvinilCoresRef}
							className={`suvinilCoresSection ${animateSuvinilCores ? "animateSuvinilCores" : ""}`}
						>
							<div className="suvinilCoresHero">
								{/* <span className="suvinilCoresLogo animCoresLogo">Suvinil</span> */}

								<div className="suvinilCoresTitulo animCoresTitulo">
									{ReactHtmlParser(t("casesCampanhas.suvinilCoresTitulo"))}
								</div>

								<img
									src={trianguloInvertidoAzul}
									alt=""
									className="suvinilCoresTrianguloTop animCoresTrianguloTop"
								/>
							</div>

							<div className="suvinilCoresBannerWrap">
								<iframe
									src="https://player.vimeo.com/video/998838234?autoplay=1&muted=1&loop=1&autopause=0"
									title="Vídeo ZEST"
									frameBorder="0"
									allow="autoplay; fullscreen; picture-in-picture"
									allowFullScreen
								/>
							</div>

							<div className="suvinilCoresBottom">
								<img
									src={trianguloInvertidoAzulVazio}
									alt=""
									className="suvinilCoresTrianguloBottom animCoresTrianguloBottom"
								/>
							</div>
						</section>
					</CssSuvinilCores>

					<CssSuvinilCoresDetalhes>
						<section
							ref={suvinilCoresDetalhesRef}
							className={`suvinilCoresDetalhesSection ${animateSuvinilCoresDetalhes ? "animateSuvinilCoresDetalhes" : ""}`}
						>
							<div className="suvinilCoresDetalhesTexto animCoresDetalhesTexto">
								{ReactHtmlParser(t("casesCampanhas.suvinilCoresDetalhesTexto"))}
							</div>

							<div className="suvinilCoresDetalhesConteudo">
								<div className="suvinilCoresDetalhesVisual">
									<img
										src={quadroCores}
										alt=""
										className="suvinilCoresQuadro animCoresQuadro"
									/>
									<img
										src={celularCores}
										alt=""
										className="suvinilCoresCelular animCoresCelular"
									/>
								</div>

								<div className="suvinilCoresMetricas">
									<div className="suvinilCoresMetrica suvinilCoresMetrica10 animCoresMetrica10">
										<strong>+12</strong>
										<span>{t("casesCampanhas.suvinilCoresSeguidores")}</span>
									</div>

									<div className="suvinilCoresMetrica suvinilCoresMetrica30 animCoresMetrica30">
										<strong>+350</strong>
										<span>{t("casesCampanhas.suvinilCoresDesdobramentos")}</span>
									</div>

									<img
										src={setaVirada}
										alt=""
										className="suvinilCoresSeta animCoresSeta"
									/>
								</div>
							</div>
						</section>

						<div className="caseTop">
							<a href="/CasesjogarJunto" className="caseNav caseNavHome">
								<img src={setaAzul} alt="" />
								<span>{t("botoes.voltar")}</span>
							</a>

							<a href="/CasesTransmissaoAoVivo" className="caseNav caseNavNext">
								<span>{t("casesConteudoSocial.proximoCase")}</span>
								<img src={setaAzul} alt="" />
							</a>
						</div>
					</CssSuvinilCoresDetalhes>

					<CssSuvinilCoresFilmes>
						<section
							ref={suvinilCoresFilmesRef}
							className={`suvinilCoresFilmesSection ${animateSuvinilCoresFilmes ? "animateSuvinilCoresFilmes" : ""}`}
						>
							<div className="suvinilCoresFilmesTopo">
								<div className="suvinilCoresFilmesTexto animCoresFilmesTexto">
									{ReactHtmlParser(t("casesCampanhas.suvinilCoresFilmesTexto"))}
								</div>
								<img
									src={quadradoVermelho}
									alt=""
									className="suvinilCoresFilmesQuadrado animCoresFilmesQuadrado"
								/>
							</div>

							<div className="suvinilCoresFilmesConteudo">
								<div className="suvinilCoresFilmesBlocoAzul animCoresFilmesBlocoAzul" />

								<img
									src={filmesCores}
									alt=""
									className="suvinilCoresFilmesImagem animCoresFilmesImagem"
								/>

								<img
									src={trianguloVermelhoCores}
									alt=""
									className="suvinilCoresFilmesTriangulo animCoresFilmesTriangulo"
								/>

								{/* <div className="suvinilCoresFilmes70 animCoresFilmes70">
									<strong>70k</strong>
									<div>{ReactHtmlParser(t("casesCampanhas.suvinilCoresFilmes70Texto"))}</div>
								</div> */}

								<div className="suvinilCoresFilmes200 animCoresFilmes200">
									<strong>200k</strong>
									<div className="suvinilCoresFilmesSocial">
										<a href="#facebook" aria-label="Facebook">
											<img src={facebookCores} alt="" />
										</a>
										<a href="#instagram" aria-label="Instagram">
											<img src={instagramCores} alt="" />
										</a>
										<a href="#youtube" aria-label="YouTube">
											<img src={youtubeCores} alt="" />
										</a>
										<a href="#zest" aria-label="Zest">
											<img src={quadradoVermelho} alt="" />
										</a>
										<span>{t("casesCampanhas.suvinilCoresFilmesViews")}</span>
									</div>
								</div>

								<img
									src={notebookCores}
									alt=""
									className="suvinilCoresNotebook animCoresNotebook"
								/>

								<img
									src={trianguloVermelhoVazado}
									alt=""
									className="suvinilCoresFilmesVazado animCoresFilmesVazado"
								/>
							</div>
						</section>
					</CssSuvinilCoresFilmes>

                 </div>

				<div
						className="campanhasTabPanel"
						role="tabpanel"
						hidden={activeCase !== "edp"}
				>
					<CssEdpCase>
						<section
								ref={edpCaseRef}
								className={`edpCaseSection ${animateEdpCase ? "animateEdpCase" : ""}`}
						>
								<div className="edpCaseTitulo animEdpTitulo">
										{ReactHtmlParser(t("casesCampanhas.edpTitulo"))}
								</div>

								<div className="edpCaseCapaWrap">
									<img
											src={trianguloEdpSuperior}
											alt=""
											className="edpCaseTrianguloSuperior animEdpTrianguloSuperior"
									/>

									<img
											src={trianguloEdpInferior}
											alt=""
											className="edpCaseTrianguloInferior animEdpTrianguloInferior"
									/>

									<img
											src={capaEdp}
											alt="EDP"
											className="edpCaseCapa animEdpCapa"
									/>
								</div>
						</section>
					</CssEdpCase>

					<CssEdpSocial>
						<section
							ref={edpSocialRef}
							className={`edpSocialSection ${animateEdpSocial ? "animateEdpSocial" : ""}`}
						>
							<div className="edpSocialHeader">
								<h2 className="animEdpSocialTitulo">
									{ReactHtmlParser(t("casesCampanhas.edpSocialTitulo"))}
									</h2>
								<div className="edpSocialSubtitulo animEdpSocialSubtitulo">
									{ReactHtmlParser(t("casesCampanhas.edpSocialSubtitulo"))}
								</div>
							</div>

							<img
								src={setaDireitaEdp}
								alt=""
								className="edpSocialSeta animEdpSocialSeta"
							/>

							<div className="edpSocialMetric edpSocialMetric100 animEdpSocial100">
								<strong>1.700</strong>
								{ReactHtmlParser(t("casesCampanhas.edpSocial100Texto"))}
							</div>

							<div className="edpSocialVisual">
								<img
									src={cardEdp1}
									alt=""
									className="edpSocialCard edpSocialCard1 animEdpSocialCard1"
								/>
								<img
									src={celularEdp}
									alt=""
									className="edpSocialCelular animEdpSocialCelular"
								/>
								<img
									src={cardEdp2}
									alt=""
									className="edpSocialCard edpSocialCard2 animEdpSocialCard2"
								/>
							</div>

							<div className="edpSocialMetric edpSocialMetric55 animEdpSocial55">
								<strong>{ReactHtmlParser(t("casesCampanhas.edpSocial55"))}</strong>
								{ReactHtmlParser(t("casesCampanhas.edpSocial55Texto"))}
							</div>

							{/* <div className="edpSocialTextoFinal animEdpSocialFinal">
								{ReactHtmlParser(t("casesCampanhas.edpSocialTextoFinal"))}
							</div> */}
						</section>
					</CssEdpSocial>

					<CssEdpNotebook>
						<section
								ref={edpNotebookRef}
								className={`edpNotebookSection ${animateEdpNotebook ? "animateEdpNotebook" : ""}`}
						>
								<img
										src={trianguloVermelhoEdp}
										alt=""
										className="edpNotebookTriangulo edpNotebookTrianguloLeft animEdpNotebookTriangulo"
								/>
								<img
										src={triangulosJuntosEdp}
										alt=""
										className="edpNotebookTriangulo edpNotebookTriangulosTopRight animEdpNotebookTriangulo"
								/>

								<img
										src={notebookEdp}
										alt=""
										className="edpNotebookImagem animEdpNotebookImagem"
								/>

								<div className="edpNotebookConteudo">
										<div className="edpNotebookTextoVermelho animEdpNotebookTextoVermelho">
												{ReactHtmlParser(t("casesCampanhas.edpNotebookTextoVermelho"))}
										</div>

										<div className="edpNotebookSocial">
												<a href="#instagram-edp" aria-label="Instagram" className="animEdpNotebookIcone animEdpNotebookInstagram">
														<img src={instagramEdp} alt="" />
												</a>
												<a href="#youtube-edp" aria-label="YouTube" className="animEdpNotebookIcone animEdpNotebookYoutube">
														<img src={youtubeEdp} alt="" />
												</a>
												<a href="#zest-edp" aria-label="Zest" className="animEdpNotebookIcone animEdpNotebookZest">
														<img src={quadradoVermelhoEdp} alt="" />
												</a>
										</div>

										<div className="edpNotebookTextoPreto animEdpNotebookTextoPreto">
												{ReactHtmlParser(t("casesCampanhas.edpNotebookTextoPreto"))}
										</div>
								</div>

								<img
										src={setaViradaEdp}
										alt=""
										className="edpNotebookSeta animEdpNotebookSeta"
								/>

								<img
										src={quadradoVermelhoEdp}
										alt=""
										className="edpNotebookQuadrado animEdpNotebookQuadrado"
								/>
						</section>
					</CssEdpNotebook>

					<CssEdpNovoCase>
						<section
							ref={edpNovoCaseRef}
							className={`edpNovoCaseSection ${animateEdpNovoCase ? "animateEdpNovoCase" : ""}`}
						>
							<div className="edpNovoCaseTitulo animEdpNovoTitulo">
								{ReactHtmlParser(t("casesCampanhas.edpTitulo2"))}
							</div>

							<div className="edpNovoCaseVideoWrap">
								<img
									src={trianguloEdpSuperior}
									alt=""
									className="edpNovoCaseTriangulo animEdpNovoTriangulo"
								/>

								<div className="edpNovoCaseVideo animEdpNovoVideo">
										{edpNovoVideoUrl ? (
												<iframe
													src={edpNovoVideoUrl}
													title="Vídeo EDP"
													frameBorder="0"
													allow="autoplay; fullscreen; picture-in-picture"
													allowFullScreen
												/>
										) : (
												<img
													src={bannerMulherEdp}
													alt="EDP"
													className="edpNovoCaseVideoFallback"
												/>
										)}
								</div>
							</div>
						</section>
					</CssEdpNovoCase>

					<CssEdpNovoResultados>
							<section
									ref={edpNovoResultadosRef}
									className={`edpNovoResultadosSection ${animateEdpNovoResultados ? "animateEdpNovoResultados" : ""}`}
							>
									<div className="edpNovoResultadosHeader">
											<div className="edpNovoResultadosTitulo animEdpNovoResultadosTitulo">
													{ReactHtmlParser(t("casesCampanhas.edpNovoResultadosTitulo"))}
											</div>

											<div className="edpNovoResultadosTexto animEdpNovoResultadosTexto">
													{ReactHtmlParser(t("casesCampanhas.edpNovoResultadosTexto"))}
											</div>
									</div>

									<img
											src={trianguloVermelhoCoresEdp}
											alt=""
											className="edpNovoResultadosTrianguloTop animEdpNovoResultadosTrianguloTop"
									/>

									<div className="edpNovoResultadosVisual">
											<img
													src={pcEdp}
													alt=""
													className="edpNovoResultadosPc animEdpNovoResultadosPc"
											/>

											<div className="edpNovoResultadosMetricas">
													<div className="edpNovoResultadosMetrica edpNovoResultadosMetricaEstados animEdpNovoResultadosEstados">
															<strong>3</strong>
															<span>{t("casesCampanhas.edpNovoResultadosEstados")}</span>
															<small>{t("casesCampanhas.edpNovoResultadosFotos")}</small>
													</div>
											</div>
									</div>

									<div className="edpNovoResultadosMetrica edpNovoResultadosMetricaPecas animEdpNovoResultadosPecas">
											<strong>+50</strong>
											<span>{t("casesCampanhas.edpNovoResultadosPecas")}</span>
									</div>

									<img
											src={trianguloVermelhoInvertidoEdp}
											alt=""
											className="edpNovoResultadosTrianguloRight animEdpNovoResultadosTrianguloRight"
									/>

									<img
											src={setaViradaEdp}
											alt=""
											className="edpNovoResultadosSeta animEdpNovoResultadosSeta"
									/>

									<img
											src={cardsEdp}
											alt=""
											className="edpNovoResultadosCards animEdpNovoResultadosCards"
									/>
							</section>
					</CssEdpNovoResultados>

					<CssEdpFullResponsa>
							<section
									ref={edpFullResponsaRef}
									className={`edpFullResponsaSection ${animateEdpFullResponsa ? "animateEdpFullResponsa" : ""}`}
							>
									<div className="edpFullResponsaTextoBox">
											<h2 className="animEdpFullTitulo">
													{ReactHtmlParser(t("casesCampanhas.edpFullResponsaTitulo"))}
											</h2>

											<div className="edpFullResponsaTexto animEdpFullTexto">
													{ReactHtmlParser(t("casesCampanhas.edpFullResponsaTexto"))}
											</div>
									</div>

									<img
											src={fotoJuntoEdp1}
											alt=""
											className="edpFullResponsaFoto edpFullResponsaFoto1 animEdpFullFoto1"
									/>

									<img
											src={fotoJuntoEdp2}
											alt=""
											className="edpFullResponsaFoto edpFullResponsaFoto2 animEdpFullFoto2"
									/>

									<div className="edpFullResponsaMetrica animEdpFullMetrica">
											<strong>43%</strong>
											<span>{t("casesCampanhas.edpFullResponsaMetrica")}</span>
									</div>
							</section>
					</CssEdpFullResponsa>
                </div>

				<div
						className="campanhasTabPanel"
						role="tabpanel"
						hidden={activeCase !== "ecom"}
				>
					<CssEcomCase>
						<section className={`ecomHeroSection ${animateEcomTitulo ? "animateEcomTitulo" : ""}`}>
							<h1 className="ecomHeroTitulo animEcomTitulo">
								{ReactHtmlParser(t("casesCampanhas.ecomTitulo"))}
							</h1>
						</section>

						<section
							ref={ecomVideoRef}
							className={`ecomVideoSection ${animateEcomVideo ? "animateEcomVideo" : ""}`}
						>
							<div className="ecomVideoWrap animEcomVideo">
								<iframe
									src={ecomVideoUrl}
									title="Vídeo Ecom"
									frameBorder="0"
									allow="autoplay; fullscreen; picture-in-picture"
									allowFullScreen
								/>
							</div>
						</section>

						<section
							ref={ecomCelularRef}
							className={`ecomCelularSection ${animateEcomCelular ? "animateEcomCelular" : ""}`}
						>
							<div className="ecomCelularTexto animEcomCelularTexto">
								{ReactHtmlParser(t("casesCampanhas.ecomCelularTexto"))}
							</div>

							<img
								src={triangulosJuntosEcom}
								alt=""
								className="ecomTriangulosJuntos animEcomTriangulos"
							/>

							<img
								src={celularEcom}
								alt=""
								className="ecomCelularImg animEcomCelularImg"
							/>

							<img
								src={setaViradaEcom}
								alt=""
								className="ecomCelularSeta animEcomCelularSeta"
							/>

							<div className="ecomMetrica ecomMetrica30 animEcomMetrica30">								
								{ReactHtmlParser(t("casesCampanhas.ecom30Texto"))}
							</div>

							<div className="ecomMetrica ecomMetrica70 animEcomMetrica70">
								<strong>5</strong>
								<span>{ReactHtmlParser(t("casesCampanhas.ecom70Texto"))}</span>
							</div>
						</section>

						<section
							ref={ecomPostsRef}
							className={`ecomPostsSection ${animateEcomPosts ? "animateEcomPosts" : ""}`}
						>
							<div className="ecomPostsGrid">
								{ecomPosts.map((post, index) => (
									<img
										key={`ecom-post-${index}`}
										src={post}
										alt=""
										className={`ecomPostItem animEcomPost animEcomPost${index + 1}`}
									/>
								))}
							</div>

							<div className="ecomInstasGrid">
								{ecomInstas.map((insta, index) => (
									<img
										key={`ecom-insta-${index}`}
										src={insta}
										alt=""
										className={`ecomInstaItem animEcomInsta animEcomInsta${index + 1}`}
									/>
								))}
							</div>

							<img src={cardEcom} alt="" className="ecomCardImg animEcomCard" />
						</section>

						<section
							ref={ecomNotebookRef}
							className={`ecomNotebookSection ${animateEcomNotebook ? "animateEcomNotebook" : ""}`}
						>
							<div className="ecomNotebookMetric ecomNotebookMetric100 animEcomNotebook100">
								{/* <strong>100k</strong> */}
								<span>{ReactHtmlParser(t("casesCampanhas.ecom100Texto"))}</span>
							</div>

							<img src={laptopEcom} alt="" className="ecomLaptop animEcomLaptop" />

							{/* <div className="ecomNotebookMetric ecomNotebookMetric200 animEcomNotebook200">
								<strong>200k</strong>
							</div> */}

							<div className="ecomNotebookTexto animEcomNotebookTexto">
								{ReactHtmlParser(t("casesCampanhas.ecomNotebookTexto"))}
							</div>

							<img src={zBegeEcom} alt="" className="ecomZBege animEcomZBege" />

							<div className="ecomNotebookSocial">
								{/* <a href="#facebook-ecom" aria-label="Facebook" className="animEcomSocial animEcomSocial1">
									<img src={facebookEcom} alt="" />
								</a>
								<a href="#instagram-ecom" aria-label="Instagram" className="animEcomSocial animEcomSocial2">
									<img src={instagramEcom} alt="" />
								</a>
								<a href="#youtube-ecom" aria-label="YouTube" className="animEcomSocial animEcomSocial3">
									<img src={youtubeEcom} alt="" />
								</a>
								<a href="#zest-ecom" aria-label="Zest" className="animEcomSocial animEcomSocial4">
									<img src={zeEcom} alt="" />
								</a> */}
								<span className="ecomNotebookViews">{t("casesCampanhas.ecomViews")}</span>
							</div>
						</section>

						<section
							ref={ecomFotosRef}
							className={`ecomFotosSection ${animateEcomFotos ? "animateEcomFotos" : ""}`}
						>
							<div className="ecomFotosGrid">
								{ecomFotos.map((foto, index) => (
									<img
										key={`ecom-foto-${index}`}
										src={foto}
										alt=""
										className={`ecomFotoItem animEcomFoto animEcomFoto${index + 1}`}
									/>
								))}
							</div>
						</section>
					</CssEcomCase>
				</div>

				<div className="clear" />
			{/* <Footer /> */}
		</>
	);
};

export default CasesCampanhas;
